// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { string, number, boolean } from "@altostra/type-validations/lib/primitives";

export const isGetApiKeyDetailsResult = objectOf({
  name: string,
  api_key: string,
  permissions: arrayOf(number),
  ip_whitelist: maybe(string),
  internal_webhook_enabled: maybe(boolean),
  io: maybe(boolean),
});
